import React from 'react'
import { getDynamicModule, _withMFModule, parseScopeModule as _parseScopeModule, loadDynamicModule, utils } from '@sui/runtime';
import NotFoundComponentModule from '../NotFoundComponentModule'
const _get_sui_webpack_remote_time = window._get_sui_webpack_remote_time  || new Date().getTime();
// 远程remote container urls
const remotesUrls = {

}

/**
 * 解析并读取远程模块
 * @param scope 
 * @param module 
 */
function __parseScopeModule(scope, module, success, error ){
    const oldVerScope = scope.replace(/_\$\d+\$_/g, '_'); // 兼容老版本
    if ( !window[scope] && !window[oldVerScope]) {
        typeof error === 'function' && error()
    } else {
        typeof success === 'function' && success(loadDynamicModule(scope, module))
    }
}
const parseScopeModule = _parseScopeModule || __parseScopeModule;

/**
 * 解析组件scope
 * @param {*} name 
 * @param {*} prefix 
 * @returns 
 */
function parseModuleName(name, prefix){
    return (prefix || '') + name.replace(/^@/, '$').replace(/[@\/\\\.-]/g, function(char){
        return "_$" + char.charCodeAt() + "$_"
    })
}

/**
** 解析组件包名
** @param {*} scope
*/
function parsePackageName(scope){
    return scope ? scope.replace(/^\$/, '@').replace(/_\$(\d+)\$_/g, function(char, code){
        return String.fromCharCode(Number(code))
    }) : "";
}

/**
** 兼容老的方式
*/
function oldParsePackageName(scope){
    return parsePackageName(scope).replace(/_/, "/");
}

/**
** 转成老的scope
*/
function oldParseScope(scope){
    return scope.replace(/_\$(\d+)\$_/g, '_');
}

/**
** 判断是新的转换方式
**/
function isNewParsedPackageName(scope){
    return /_\$(\d+)\$_/.test(scope || "")
}

/**
* 获取 远程微应用模块名
**/
export function getMFMicroAppModuleName(microApp){
    if( microApp ){
        let name = 'MicroApp';
        if( typeof microApp === 'string' ){
            name = microApp;
        } else if( typeof microApp === 'object' ){
            name = microApp.name || name;
            if( microApp.entry ){
                name = name + '_Entry_' + microApp.entry;
            }
        }
        return name;
    }
}

/**
* 获取导入MF出错渲染逻辑
**/
function getImportMFError(_, inject, errMsg){
    if( process.env.NODE_ENV === 'development' ){
        _( function(){
            return React.createElement(NotFoundComponentModule, { message: errMsg }  )
        } )
    } else {
        inject(errMsg)
    }
}

/**
** 获取远程入口
**/
function getRemoteUrl(scope, packageName,  version, filename, tt){
    let oldScope = isNewParsedPackageName(scope) ? oldParseScope(scope) : scope;
    scope = isNewParsedPackageName(scope) ? scope : parseModuleName(packageName);
    let _remotesUrls = Object.assign({}, remotesUrls, window._sui_webpack_remote_urls)
    let remoteConf = scope && _remotesUrls[scope] ? _remotesUrls[scope] : ( packageName && _remotesUrls[packageName] ? _remotesUrls[packageName] : undefined );
    if ( !remoteConf && oldScope) {
        remoteConf = _remotesUrls[oldScope];
    }
    let runtimeRemote, runtimeRemoteUrls = window._sui_webpack_remote_urls;
    if( typeof runtimeRemoteUrls === 'object' && runtimeRemoteUrls ){
        runtimeRemote = scope && runtimeRemoteUrls[scope] ? runtimeRemoteUrls[scope] : ( packageName && runtimeRemoteUrls[packageName] ? runtimeRemoteUrls[packageName] : undefined  )
    }
    const get_remote_url = typeof window._get_sui_webpack_remote_url === "function" ? window._get_sui_webpack_remote_url : undefined;
    const parse_remote_url = (conf, runtime) => {
        if( typeof conf === "object" && conf && get_remote_url){
            return runtime ? get_remote_url( conf.name || packageName, conf.path, conf.ver || version, conf.filename || filename ) : get_remote_url( conf.name || packageName, conf.path, version || conf.ver, filename || conf.filename )
        }
        return typeof conf === "string" ? conf : ""
    }
    let remote_url = parse_remote_url(runtimeRemote, true) || parse_remote_url(remoteConf);

    if ( !remote_url && get_remote_url && packageName ){
        remote_url = get_remote_url( packageName, null, version, filename );
    }
    if ( !remote_url && get_remote_url && scope && scope!==packageName ){
        remote_url = get_remote_url( scope, null, version, filename );
    }
    if ( !remote_url && get_remote_url && oldScope && oldScope !== packageName ){
        remote_url = get_remote_url( oldScope, null, version, filename );
    }
    let remoteUrl = typeof remote_url === "string" && remote_url ? remote_url : "";
    if( remoteUrl && (tt || window._sui_webpack_remote_url_timestamp) ){
        remoteUrl = utils.add_url_query(remoteUrl, '_tt', /string|number/i.test(typeof tt) ? tt : _get_sui_webpack_remote_time, true)
    }
    if( typeof window._filter_sui_webpack_remote_url === 'function' ){
        remoteUrl = window._filter_sui_webpack_remote_url(remoteUrl, {scope, packageName, version, filename}) || remoteUrl
    }
    if( packageName && window.g_sui ){
        window.g_sui.remotesMFused = window.g_sui.remotesMFused || {};
        window.g_sui.remotesMFused[packageName] = remoteUrl;
    }
    return remoteUrl;
}

/**
 * 导入远程mf容器模块
 * @param {*} modulePath 
 * @param {*} packageName 
 * @param {*} version 
 * @param {*} filename 
 * @returns 
 */
export function importMF(modulePath, packageName, version, filename){
    const index = modulePath.indexOf('/');
    if ( index < 0 ) {
        return new Promise((_, inject)=>{
            getImportMFError(_, inject, `importMF: bad Module Name ${modulePath}, should match pattern 'remoteScope/moduleName`)
        })
    }
    const scope = modulePath.slice(0, index);
    const module = modulePath.slice(index + 1);
    let remote_url = getRemoteUrl(scope, packageName || (isNewParsedPackageName(scope) ? parsePackageName(scope) : oldParsePackageName(scope)), version, filename);
    return new Promise((_, inject)=>{
        
        parseScopeModule(scope, module, _, () => {
            remote_url ? getDynamicModule(remote_url, scope, module).then(_).catch((error)=>{
                console.error(error)
                getImportMFError(_, inject, `importMF: load remoteModule \`${modulePath}\` failed. Please check the remote url ${remote_url}`)
            }) : getImportMFError(_, inject, `importMF: remote url for "${scope}" is not defined.`)
        } )
    })
}

/**
** 导入远程mf 微应用
** @param {*} microApp
**/
export function importMFApp(scope, microApp){
    const module = getMFMicroAppModuleName(microApp)
    return importMF(`${scope}/${module}`)
}

/**
 * 加载远程组件
 * @param {*} componentName 
 * @param {*} version 
 * @param {*} filename 
 * @returns 
 */
export function importMFComponent(componentName, version, filename ){
    const index = componentName.indexOf('.');
    if ( index < 0 ) {
        return new Promise((_, inject)=>{
            getImportMFError(_, inject, `importMFComponent: bad component Name ${componentName}, should match pattern 'remotePackage.componentName`)
        })
    }
    const packageName = componentName.slice(0, index);
    const scope = parseModuleName( packageName )
    const component = componentName.slice(index + 1);
    let remote_url = getRemoteUrl(scope, packageName, version, filename);
    
    return new Promise((_, inject)=>{
                parseScopeModule(scope, component, _, () => {
                    remote_url ? getDynamicModule(remote_url, scope, component).then(_).catch((error)=>{
                            console.error(error)
                            getImportMFError(_, inject, `importMFComponent: load remoteComponent \`${componentName}\` failed. Please check the remote url ${remote_url}`)
                        }) : getImportMFError(_, inject, `importMFComponent: no remote url for "${packageName}"`)
                })
            })
}


/**
 * 依赖
 * @param mfObjArr 
 * @param component 
 * @param fallback 
 * @returns 
 */
export function withMFModule(mfObjArr, component, fallback){
    const _mfObjArr = (mfObjArr || []).map(item=>{
        return typeof item === 'string' ? importMF(item) : item;
    })
    return _withMFModule(_mfObjArr, component, fallback)
}